import { useMemo } from 'react';
import equal from 'fast-deep-equal';

export function ProductOptionValue({
  inventory,
  isLoading,
  isSelected,
  selected,
  name,
  product,
  selectedOptions,
  setSelectedOptions,
  value,
  isSoldOut,
  moreThanTwoOptions,
  secondOptionIsSoldOut,
  needsSelection,
  optionChanges,
  setOptionChanges,
}) {
  const newSelectedOptions = useMemo(() => {
    return selectedOptions
      ? {
          ...selectedOptions,
          [name]: value,
        }
      : null;
  }, [name, selectedOptions, value]);

  const variantFromOptionValue = useMemo(() => {
    if (!newSelectedOptions) return null;
    return product.variants?.find(({ selectedOptionsMap }) => {
      return equal(newSelectedOptions, selectedOptionsMap);
    });
  }, [newSelectedOptions, product.variants]);

  const loadAsSoldOut = isSoldOut || secondOptionIsSoldOut;

  const optionValueIsAvailable = loadAsSoldOut
    ? false
    : inventory?.variants?.[variantFromOptionValue?.id]?.availableForSale ||
      false;
  const disabled = isLoading || !variantFromOptionValue;
  const crossedOutClass = 'relative opacity-50 text-gray overflow-hidden after:h-[.5px] after:w-[150%] after:absolute after:left-[-14px] after:bg-gray after:top-1/2 after:rotate-[35deg] before:h-[.5px] before:w-[150%] before:absolute before:left-[-14px] before:bg-gray before:top-1/2 before:rotate-[-35deg]';
  const validClass = !disabled
    ? 'md:hover:border-text text-text bg-offWhite'
    : 'cursor-not-allowed hidden';

  const unavailableClass = moreThanTwoOptions
    ? loadAsSoldOut
      ? crossedOutClass
      : needsSelection
      ? ''
      : !optionValueIsAvailable && !disabled
      ? crossedOutClass
      : ''
    : !optionValueIsAvailable && !disabled
    ? 'relative opacity-50 text-gray overflow-hidden after:h-[.5px] after:w-[150%] after:absolute after:left-[-14px] after:bg-gray after:top-1/2 after:rotate-[35deg] before:h-[.5px] before:w-[150%] before:absolute before:left-[-14px] before:bg-gray before:top-1/2 before:rotate-[-35deg]'
    : '';
  const selectedClass = selected ? (isSelected ? 'bg-white border border-primary' : '') : '';

  return (
    <button
      aria-label={value}
      className={`shadow-hairline h-10 min-w-14 px-3 transition ${validClass} ${unavailableClass} ${selectedClass}`}
      disabled={disabled}
      onClick={() => {
        if (isSelected && selected) return;
        if (isSelected && !selected) {
          setOptionChanges({
            ...optionChanges,
            [name]: true,
          });
        } 
        setSelectedOptions(newSelectedOptions);
      }}
      type="button"
    >
      {value}
    </button>
  );
}

ProductOptionValue.displayName = 'ProductOptionValue';
